<template>
  <div class="subscribe">
    <!-- 头部 -->
    <div class="home-header-box clear">
      <a class="home-logo fl"><img class="display-a" :src="logo" /></a>
      <div class="home-search" @click="jumpSearch">
        <input disabled type="text" placeholder="搜索" />
      </div>
      <a class="fr camera-a" @click="jumpDown"></a>
    </div>
    <!-- 频道 -->
    <div class="par-two" style="padding-top: 60px">
      <div :class="['home-title-div', tabMenuFlag ? 'tabActive' : '']">
        <ul class="home-title">
          <li
            v-for="(item, index) in tabMenus"
            :key="index"
            :class="{ 'home-title-li': tabIndex == index }"
            @click="checkTab(index, item)"
          >
            <a>{{ item.name }}</a>
          </li>
        </ul>
        <i class="home-yiying"></i>
        <!-- <a v-if="tabMenus.length > 5" @click="jumpDown" class="home-title-more"></a> -->
      </div>
    </div>
    <!-- 金刚区 -->
    <ul class="subscriptions-ul flex justify-bet Subscribe-ul">
      <li class="Subscribe-li1">
        <a @click="jumpPage2(0)"> <i></i><span class="fl">我的订阅</span> </a>
      </li>
      <li class="Subscribe-li2">
        <a @click="jumpPage2(1)"> <i></i><span class="fl">申请入驻</span> </a>
      </li>
      <li class="Subscribe-li3" @click="jumpAllType">
        <a><i></i><span class="fl">全部分类</span> </a>
      </li>
    </ul>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <!-- 列表前三条 -->
      <div class="listBox">
        <!-- 标题 -->
        <div class="titleBox">热门文章</div>
        <!-- 小图 -->
        <div
          v-for="item in hotList"
          :key="item.id"
          :class="[
            'item',
            'b_img',
            item.app_card == 0 ? 'flex justify-bet' : '',
          ]"
          @click="jumpDetails(item.share_url)"
        >
          <div
            :class="[
              'info',
              item.app_card == 0
                ? 'flex justify-bet flex-column'
                : item.app_card == 1
                ? 'flex justify-bet'
                : '',
            ]"
          >
            <p
              :class="[
                'title van-multi-ellipsis--l3',
                item.app_card == 1 ? 'flex_1 pr12' : '',
              ]"
            >
              {{ item.title }}
            </p>
            <div
              v-if="item.app_card == 0"
              class="option flex align-center mt12"
            >
              <div class="userBox flex align-center">
                <img :src="item.user.image" alt="" />
                <span>{{ item.user.nickname }}</span>
              </div>
              <span class="time">{{ item.published_des }}</span>
            </div>
            <van-image
              lazy-load
              fit="cover"
              width="120"
              height="80"
              :src="item.image"
              v-if="item.app_card == 1"
            />
          </div>
          <!-- 大图 -->
          <div v-if="item.app_card == 2" class="imgBox mt12">
            <van-image
              lazy-load
              fit="cover"
              width="100%"
              height="100%"
              :src="item.image"
            />
            <i class="playBtn"></i>
          </div>
          <!-- 三图 -->
          <div v-if="item.app_card == 3" class="imgBoxs mt12">
            <van-image
              lazy-load
              fit="cover"
              class="img"
              v-for="(elem, index) in item.images"
              :key="index"
              :src="elem"
            />
            <span v-if="item.images.length > 3" class="count">5图</span>
          </div>
          <div
            v-if="!(item.app_card == 0)"
            class="option flex align-center mt12"
          >
            <div class="userBox flex align-center">
              <img :src="item.user.image" alt="" />
              <span>{{ item.user.nickname }}</span>
            </div>
            <span class="time">{{ item.published_des }}</span>
          </div>
        </div>
      </div>
      <!-- 后几条 -->
      <div class="listBox">
        <div class="titleBox" @click="jumpAllType">
          最新发布<span>全部</span>
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="initDyNewSend"
          :immediate-check="true"
        >
          <van-cell v-for="item in newSendList" :key="item.id">
            <div
              :class="[
                'item',
                'b_img',
                item.app_card == 0 ? 'flex justify-bet' : '',
              ]"
              @click="jumpDetails(item.share_url)"
            >
              <div
                :class="[
                  'info',
                  item.app_card == 0
                    ? 'flex justify-bet flex-column'
                    : item.app_card == 1
                    ? 'flex justify-bet'
                    : '',
                ]"
              >
                <p
                  :class="[
                    'title van-multi-ellipsis--l3',
                    item.app_card == 1 ? 'flex_1 pr12' : '',
                  ]"
                >
                  {{ item.title }}
                </p>
                <div
                  v-if="item.app_card == 0"
                  class="option flex align-center mt12"
                >
                  <div class="userBox flex align-center">
                    <img :src="item.user.image" alt="" />
                    <span>{{ item.user.nickname }}</span>
                  </div>
                  <span class="time">{{ item.published_des }}</span>
                </div>
                <van-image
                  lazy-load
                  fit="cover"
                  width="120"
                  height="80"
                  :src="item.image"
                  v-if="item.app_card == 1"
                />
              </div>
              <!-- 大图 -->
              <div v-if="item.app_card == 2" class="imgBox mt12">
                <van-image
                  lazy-load
                  fit="cover"
                  width="100%"
                  height="100%"
                  :src="item.image"
                />
                <i class="playBtn"></i>
              </div>
              <!-- 三图 -->
              <div v-if="item.app_card == 3" class="imgBoxs mt12">
                <van-image
                  lazy-load
                  fit="cover"
                  class="img"
                  v-for="(elem, index) in item.images"
                  :key="index"
                  :src="elem"
                />
                <span v-if="item.images.length > 3" class="count">5图</span>
              </div>
              <div
                v-if="!(item.app_card == 0)"
                class="option flex align-center mt12"
              >
                <div class="userBox flex align-center">
                  <img :src="item.user.image" alt="" />
                  <span>{{ item.user.nickname }}</span>
                </div>
                <span class="time">{{ item.published_des }}</span>
              </div>
            </div>
          </van-cell>
        </van-list>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import { getInfomation, getDyHot, getDyNewSend } from "@/request/api";
import { myListener } from "../../../../../util";
import { navigate, checkWx } from "@/pages/index/custom";
import Contents from "@/request/base.default.js";
import { Toast } from "vant";

export default {
  data() {
    return {
      test: require("./images/img1.png"),
      logo: require("./images/indexLogo.png"),
      // 选项卡菜单
      tabMenus: [],
      tabIndex: 0,
      // 热门列表
      hotList: [],
      // 最新发布
      newSendList: [],
      listPage: 1,
      loading: false, // 加载中
      finished: false, // 加载完毕
      tabMenuFlag: false,
      isLoading: false,
    };
  },
  methods: {
    // tab选项卡
    checkTab(index, item) {
      if (item.type && item.type === 1) {
        return false;
      } else {
        navigate({
          path: "/information",
          query: { index: index, id: item.id },
        });
      }
      this.tabIndex = index;
    },
    // 获取栏目
    initIndexData() {
      getInfomation()
        .then((res) => {
          let { show, error_code } = res;
          if (error_code === 0) {
            this.tabMenus = show;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 订阅号热门文章
    initDyHot() {
      getDyHot()
        .then((res) => {
          let { data, error_code } = res;
          if (error_code === 0) {
            this.hotList = data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 最细发布
    initDyNewSend() {
      getDyNewSend({
        page: this.listPage,
        pcount: 10,
      })
        .then((res) => {
          let { data, error_code } = res;
          this.isLoading = false;
          if (error_code === 0) {
            if (data.length === 0 || !data) {
              this.finished = true;
              return false;
            }
            data.map((item) => this.newSendList.push(item));
            this.listPage++;
            this.loading = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    // 跳到全部分类
    jumpAllType() {
      navigate("/allType");
    },
    jumpDown() {
      if (checkWx()) {
        navigate("", Contents.downURL + "?mini=1");
      } else {
        navigate("", Contents.downURL);
      }
    },
    jumpSearch() {
      window.localStorage.setItem("h5_index_search_focus", 1);
      navigate("", Contents.mainURL + "/app/index/search");
    },
    // 金刚区跳转
    jumpPage2(index) {
      if (index === 0) {
        navigate("/myDy");
      } else {
        if (checkWx()) {
          navigate("", Contents.downURL + "?mini=1");
        } else {
          navigate("", Contents.downURL);
        }
      }
    },
    // 详情页跳转
    jumpDetails(url) {
      navigate("", url);
    },
    // 上拉刷新
    onRefresh() {
      this.hotList = [];
      this.newSendList = [];
      this.listPage = 1;
      this.loading = true;
      this.finished = false;
      this.initDyHot();
      this.initDyNewSend();
    },
  },
  created() {
    this.tabIndex = this.$route.query.id;
    this.initIndexData();
    this.initDyHot();
    // this.initDyNewSend();
    this.listen = myListener(
      window,
      "scroll",
      (e) => {
        var scrollTop =
          e.target.documentElement.scrollTop || e.target.body.scrollTop;
        if (scrollTop > 180) {
          this.tabMenuFlag = true;
        } else {
          this.tabMenuFlag = false;
        }
      },
      true
    );
  },
  destroyed() {
    this.listen();
  },
};
</script>

<style lang="less" scoped>
.tabActive {
  position: fixed;
  top: 3rem;
  left: 0;
  background: #fff;
  z-index: 10000;
  box-sizing: border-box;
  padding: 0 1.25rem;
  width: 100%;
}
.titleBox {
  width: 100%;
  height: 3.75rem;
  box-sizing: border-box;
  padding: 0 0.625rem;
  font-size: 20px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  position: relative;
  line-height: 3.75rem;
  span {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    padding-right: 1.25rem;
    background: url(./images/icon_news_right.png) no-repeat center right;
    background-size: 1rem 1rem;
    font-size: 12px;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
  }
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    margin-top: -0.625rem;
    left: 0;
    width: 3px;
    height: 20px;
    background: rgba(255, 76, 103, 1);
    border-radius: 10px;
  }
}
.subscribe {
  padding-bottom: 3.75rem;
}
.userBox {
  height: 1.5rem;
  line-height: 1.5rem;
  img {
    width: 1.5rem;
    height: 24px;
    object-fit: cover;
    border-radius: 50%;
    display: block;
    overflow: hidden;
  }
  span {
    font-size: 12px;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    margin: 0 6px;
  }
}
.listBox {
  box-sizing: border-box;
  padding: 0 20px;
  .pr12 {
    padding-right: 0.75rem;
  }
  .mt8 {
    margin-top: 0.5rem !important;
  }
  .mt12 {
    margin-top: 0.75rem !important;
  }
  .item {
    border-bottom: 1px solid #eee;
  }
  .s_img {
    padding: 20px 0;
    box-sizing: border-box;
    .info {
      box-sizing: border-box;
      padding-right: 0.75rem;
    }
    .title {
      font-size: 18px;
      font-weight: 500;
      color: rgba(34, 34, 34, 1);
      line-height: 25px;
    }
  }
  .b_img {
    box-sizing: border-box;
    padding: 20px 0;
    .living {
      position: absolute;
      top: 0.75rem;
      right: 0.75rem;
      height: 20px;
      line-height: 20px;
      padding-right: 8px;
      padding-left: 22px;
      background: url(../../../../assets/img/ic_live_s.png) no-repeat 8px center;
      background-size: 12px 12px;
      background-color: #ff4c67;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      border-radius: 2px;
    }
    .huigu {
      position: absolute;
      top: 0.75rem;
      right: 0.75rem;
      height: 20px;
      line-height: 20px;
      padding: 0 8px;
      background-color: #00c5aa;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      border-radius: 2px;
      text-align: center;
    }
    .yugao {
      position: absolute;
      top: 0.75rem;
      right: 0.75rem;
      height: 20px;
      line-height: 20px;
      padding: 0 8px;
      background-color: #2e8cff;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      border-radius: 2px;
      text-align: center;
    }
    .playBtn {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1.75rem;
      margin-top: -1.75rem;
      width: 3.5rem;
      height: 3.5rem;
      background: url(../../../../assets/img/ic_playBtn.png) no-repeat;
      background-size: 100% 100%;
    }
    .liveBtn {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1.75rem;
      margin-top: -1.75rem;
      width: 3.5rem;
      height: 3.5rem;
      background: url(../../../../assets/img/ic_live_b.png) no-repeat;
      background-size: 100% 100%;
    }
    .title {
      font-size: 18px;
      font-weight: 500;
      color: rgba(34, 34, 34, 1);
      line-height: 26px;
    }
    .imgBox {
      width: 100%;
      height: 11.75rem;
      border-radius: 6px;
      overflow: hidden;
      position: relative;
    }
    .imgBoxs {
      width: 100%;
      border-radius: 6px;
      overflow: hidden;
      position: relative;
      .img {
        float: left;
        width: 32.8%;
        height: 4.625rem;
      }
      & > .img:nth-child(2) {
        margin: 0 0.8%;
      }
      .count {
        position: absolute;
        right: 0.5rem;
        bottom: 0.5rem;
        width: auto;
        height: 1.25rem;
        line-height: 1.25rem;
        padding: 0 0.5rem;
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        border-radius: 100px;
        background-color: rgba(0, 0, 0, 0.7);
      }
    }
  }
  .option {
    margin: 0;
    .else {
      width: 32px;
      height: 21px;
      margin-right: 4px;
      text-align: center;
      line-height: 21px;
      font-size: 9px;
      font-weight: 400;
      transform: scale(0.75);
      border-radius: 2px;
    }
    .time {
      font-size: 12px;
      font-weight: 400;
      color: rgba(167, 167, 167, 1);
      line-height: 21px;
    }
  }
}
.home-title-more {
  height: 52px;
  background-position: center center;
}
</style>
